import React, { useEffect, useState } from "react"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  styled,
} from "@mui/material"
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'

import { colors, opacity } from "../../../utils/colorUtils"
import { MULTICHECKBOX_FILTER, filterConfig } from "../issueFilterUtils"

const defaultFn = () => { console.log(`setSelected has not been specified`) }

const FilterAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  minHeight: 0,
  paddingRight: '8px',
  '& .MuiAccordionSummary-content': {
    fontSize: '0.9rem',
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.75),
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: colors.awaCharcoal,
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
}))

const FilterAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  borderTop: '1px solid rgba(0, 0, 0, .125)',
  fontSize: '0.9rem',
  maxHeight: 'calc(100vh - 250px)',
  overflowY: 'auto',
  padding: theme.spacing(1),
}))

const badgeStyle = {
  backgroundColor: colors.awaOffWhite + opacity.a50,
  borderRadius: '5px',
  color: colors.awaCharcoal + opacity.a75,
  fontSize: '0.7rem',
  marginBottom: '2px',
  maxWidth: '150px',
  overflow: 'hidden',
  padding: '2px 5px 0px 5px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const MultiCheckboxFilter = ({
  filterOptions = {},
  selectedOptions = [],
  setFilter = defaultFn,
}) => {

  return (
    <FilterAccordionDetails>
      {Object.entries(filterOptions).map(([option, optionLabel]) => {
        const isSelected = selectedOptions.some(x => x === option)
        const addOption = () => setFilter(selectedOptions.concat(option))
        const removeOption = () => setFilter(selectedOptions.filter(x => x !== option))

        return <FormControlLabel
          control={
            <Checkbox
              checked={isSelected}
              onChange={isSelected ? removeOption : addOption}
              sx={{ color: colors.awaCharcoal + opacity.a50 }}
            />
          }
          key={option}
          label={
            <Typography
              float='left'
              fontSize='0.8rem'
              marginTop='3px'
              marginLeft='4px'
            >
              {optionLabel}
            </Typography>
          }
          sx={{
            height: '32px',
            minWidth: '90%',
            margin: 0,
          }}
        />
      })}
    </FilterAccordionDetails>
  )
}

const TextFilter = ({
  filterByText = '',
  setFilter = defaultFn,
}) => {
  const [currentText, setCurrentText] = useState('')

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (filterByText !== currentText) { setFilter([currentText]) }
    }, 1000)
    return () => clearTimeout(timeoutId)
  }, [currentText, filterByText, setFilter])

  useEffect(() => {
    if (filterByText === '') { setCurrentText('') }
  }, [filterByText])

  return (
    <FilterAccordionDetails>
      <TextField
        value={currentText}
        onChange={(e) => { setCurrentText(e.target.value) }}
        placeholder='Enter search text here'
        sx={{
          backgroundColor: colors.awaOffWhite,
          width: '100%',
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
          },
          '& .MuiOutlinedInput-input': {
            fontSize: '0.8rem',
            padding: '5px 8px',
          }
        }}
      />
    </FilterAccordionDetails>
  )
}

const FilterControl = ({
  filterOptions = {},
  filters,
  setFilter,
}) => {
  const [expandedFilter, setExpandedFilter] = useState('')

  return <>
    {
      Object.entries(filterConfig).map(([key, config], i) => {
        const expanded = expandedFilter === key

        return <Accordion
          disableGutters
          elevation={0}
          expanded={expanded}
          key={key}
          style={{
            // backgroundColor: expanded
            //   ? colors.awaOffWhite
            //   : colors.awaTan + (i % 2 === 0 ? '80' : '4D'),
            // border: '1px solid black',
            backgroundColor: expanded
              ? colors.awaCharcoal + opacity.a15
              : '#0000',
            color: colors.awaCharcoal,
            fontWeight: expanded ? 600 : 400,
          }}
        >
          <FilterAccordionSummary
            expandIcon={<ArrowForwardIosSharpIcon
              sx={{
                color: colors.awaCharcoal,
                fontSize: '0.9rem'
              }}
            />}
            onClick={() => { setExpandedFilter(f => f === key ? '' : key) }}
          >
            <span style={{ flexGrow: 1 }}>{config.label}</span>
            {filters[key]?.length > 0 && (
              config.type === MULTICHECKBOX_FILTER
                ? <span style={badgeStyle}>{`${(filters[key] || []).length} selected`}</span>
                : filters[key][0]?.length > 0
                && <span style={badgeStyle}>{`"${filters[key][0]}"`}</span>
            )}
          </FilterAccordionSummary>
          {
            filterConfig[key].type === MULTICHECKBOX_FILTER
              ? <MultiCheckboxFilter
                filterOptions={filterOptions[key]}
                selectedOptions={filters[key]}
                setFilter={setFilter(key)}
              />
              : <TextFilter
                filterByText={(filters[key] || [])[0]}
                setFilter={setFilter(key)}
              />
          }

        </Accordion >
      })
    }
  </>
}

export default FilterControl